export type SigningPhase = "idle" | "previewing" | "signing" | "submitting" | "finalizing";

export function getSigningPhaseKey(phase: Exclude<SigningPhase, "idle">, isDemo: boolean): string {
  if (phase === "signing") {
    return isDemo ? "signing.phases.signingDemo" : "signing.phases.signing";
  }
  return `signing.phases.${phase}`;
}
